import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be629a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-info" }
const _hoisted_2 = { class: "stock-code" }
const _hoisted_3 = { class: "stock-name" }
const _hoisted_4 = {
  key: 0,
  class: "arrow"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "行情表现", -1))
const _hoisted_9 = {
  key: 0,
  class: "table-grid"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入选价", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入选时间", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入选类型", -1))
const _hoisted_17 = { class: "value red" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "最高涨幅", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "今年涨幅", -1))
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "累计涨幅", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "今年涨幅", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近1月涨幅", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "是否新高", -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入选板块", -1))
const _hoisted_28 = { class: "value bold" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "板块热度", -1))
const _hoisted_30 = { class: "value red" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "是否入选龙虎榜", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "个股热度", -1))
const _hoisted_35 = { class: "value red" }
const _hoisted_36 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_37 = { class: "section" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "资金流向", -1))
const _hoisted_39 = { class: "table-grid" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "主力净流入", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近3日主力净流入", -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近5日主力净流入", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近10日主力净流入", -1))
const _hoisted_46 = { class: "section" }
const _hoisted_47 = { class: "section-all" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "融资融券", -1))
const _hoisted_49 = { class: "section-title section-title1" }
const _hoisted_50 = { class: "table-grid" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "两融余额", -1))
const _hoisted_53 = { class: "value" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "两融成交占比", -1))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "融资净买入", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "融券净卖出", -1))
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近5日余额变动", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近10日余额变动", -1))
const _hoisted_62 = { class: "section" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "量能态势", -1))
const _hoisted_64 = { class: "table-grid" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "成交额", -1))
const _hoisted_67 = { class: "value" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近5日均成交额", -1))
const _hoisted_69 = { class: "value" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "换手率", -1))
const _hoisted_72 = { class: "value" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "近5日换手率", -1))
const _hoisted_74 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dragon-hunter-detail", [_ctx.theme]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayCode), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.displayName), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-price", _ctx.priceClass])
      }, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.displayLastPrice), 1),
        (!_ctx.stockInfo.isSuspended)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              (_ctx.stockInfo.riseAndFall > 0)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: require('@/assets/top_light.png'),
                    alt: ""
                  }, null, 8, _hoisted_5))
                : (_ctx.stockInfo.riseAndFall < 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: require('@/assets/bottom_light.png'),
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-change", _ctx.priceClass])
      }, _toDisplayString(_ctx.formattedChange), 3),
      _createElementVNode("span", {
        class: _normalizeClass(["stock-increase", _ctx.priceClass])
      }, _toDisplayString(_ctx.formattedIncrease), 3)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_ctx.quoteData && _ctx.quoteData.selectType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.quoteData.price != null ? Number(_ctx.quoteData.price).toFixed(2) : '--'), 1),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.quoteData.selectTime)), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.iscode === '2' ? _ctx.hunterSelectTypeLabel(_ctx.quoteData.selectType) :
                            _ctx.signalSelectTypeLabel(_ctx.quoteData.selectType)), 1),
              (_ctx.iscode === '1')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_18,
                    _createElementVNode("div", {
                      class: _normalizeClass(["value", _ctx.quoteData.highPct == null ? '' : 'red'])
                    }, _toDisplayString(_ctx.formatPercents(_ctx.quoteData.highPct)), 3)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_19,
                    _createElementVNode("div", {
                      class: _normalizeClass(["value", _ctx.snapshotData.yearUpDown == null ? '' : _ctx.snapshotData.yearUpDown < 0 ? 'green' : 'red'])
                    }, _toDisplayString(_ctx.formatPct(_ctx.snapshotData.yearUpDown)), 3)
                  ], 64))
            ]),
            (_ctx.iscode === '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", _ctx.quoteData.periodPct == null ? '' : _ctx.quoteData.periodPct < 0 ? 'green' : 'red'])
                  }, _toDisplayString(_ctx.formatPercent(_ctx.quoteData.periodPct)), 3),
                  _hoisted_22,
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", _ctx.snapshotData.yearUpDown == null ? '' : _ctx.snapshotData.yearUpDown < 0 ? 'green' : 'red'])
                  }, _toDisplayString(_ctx.formatWsPercent(_ctx.snapshotData.yearUpDown)), 3)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", {
                class: _normalizeClass(["value", _ctx.snapshotData.upDownLastMonth == null ? '' : _ctx.snapshotData.upDownLastMonth < 0 ? 'green' : 'red'])
              }, _toDisplayString(_ctx.iscode === '2' ? _ctx.formatPct(_ctx.snapshotData.upDownLastMonth) :
                            _ctx.formatWsPercent(_ctx.snapshotData.upDownLastMonth)), 3),
              _hoisted_25,
              _createElementVNode("div", {
                class: _normalizeClass(["value", _ctx.snapshotData.newHigh != null && String(_ctx.snapshotData.newHigh).includes('新高') ? 'red' : ''])
              }, _toDisplayString(_ctx.snapshotData.newHigh != null ? _ctx.snapshotData.newHigh : '--'), 3)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.quoteData.plateName || '--'), 1),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatHot(_ctx.quoteData.plateHot)), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.iscode === '2' ? (_ctx.quoteData.isChose ? '是' : '否') :
                            (_ctx.quoteData.isDragonTiger ? '是' : '否')), 1),
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.iscode === '2' ? _ctx.formatHot(_ctx.quoteData.symbolHot) :
                            _ctx.formatHot(_ctx.quoteData.stockHot)), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_36, "暂无入选记录"))
    ]),
    _createElementVNode("div", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.snapshotData.inmoneyflowamt == null ? '' : _ctx.snapshotData.inmoneyflowamt < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.inmoneyflowamt)), 3),
          _hoisted_42,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.snapshotData.inmoneyflowamt3day == null ? '' : _ctx.snapshotData.inmoneyflowamt3day < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.inmoneyflowamt3day)), 3)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.snapshotData.inmoneyflowamt5day == null ? '' : _ctx.snapshotData.inmoneyflowamt5day < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.inmoneyflowamt5day)), 3),
          _hoisted_45,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.snapshotData.inmoneyflowamt10day == null ? '' : _ctx.snapshotData.inmoneyflowamt10day < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.inmoneyflowamt10day)), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, "更新于 " + _toDisplayString(_ctx.getMonthDay(_ctx.marginData.updateTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.formatWan(_ctx.marginData.balance)), 1),
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.formatPercents(_ctx.marginData.tradedRate)), 1)
        ]),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.marginData.buy == null ? '' : _ctx.marginData.buy < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatYi(_ctx.marginData.buy)), 3),
          _hoisted_58,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.marginData.sell == null ? '' : _ctx.marginData.sell < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatYi(_ctx.marginData.sell)), 3)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.marginData.day5Change == null ? '' : _ctx.marginData.day5Change < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatYi(_ctx.marginData.day5Change)), 3),
          _hoisted_61,
          _createElementVNode("div", {
            class: _normalizeClass(["value", _ctx.marginData.day10Change == null ? '' : _ctx.marginData.day10Change < 0 ? 'green' : 'red'])
          }, _toDisplayString(_ctx.formatYi(_ctx.marginData.day10Change)), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _hoisted_63,
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.amount)), 1),
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.formatMoney(_ctx.snapshotData.avgamt5day)), 1)
        ]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formatHsl(_ctx.snapshotData.hsl)), 1),
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatHsl(_ctx.snapshotData.turnover5day)), 1)
        ])
      ])
    ])
  ], 2))
}